/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    '2FA_ALREADY_ENABLED': 'Zwei-Faktor Authentifizierung ist bereits aktiviert.',
    '2FA_INVALID': 'Zwei-Faktor-Authentifizierungs Code ungültig.',
    '2FA_NOT_ENABLED': 'OTP kann nicht verifiziert werden, da Zwei-Faktor Authentifizierung deaktiviert ist.',
    '2FA_REQUIRED': 'Zwei-Faktor Authentifizierung benötigt.',
    'ACTIVE_TIME_ENTRY_EXISTS': 'Es existiert bereits ein laufender Zeiteintrag. Bitte lade die Seite neu um diesen anzuzeigen.',
    'ADDRESS_STILL_USED': 'Eine oder mehrere Adressen werden noch in entwurfs oder wiederkehrenden Rechnungen verwedendet und konnten nicht gelöscht werden.',
    'ALREADY_MEMBER': 'Du bist bereits Mitglied dieser Firma.',
    'ALREADY_SUBSCRIBED': 'Du hast bereits ein aktives Abonnement.',
    'CANNOT_DELETE_INITIAL_STATUS': 'Der Startstatus kann nicht gelöscht werden.',
    'CAN_NOT_ADD_PAYMENT_TO_INVOICE': 'Aufgrund des Status kann keine Zahlung zu dieser Rechnung hinzugefügt werden.',
    'CAN_NOT_EDIT_COMMITTED_EXPENSE': 'Bereits festgeschriebene Ausgaben können nicht mehr bearbeitet werden.',
    'COMMITTED_INVOICES_CANNOT_BE_UPDATED': 'Bereits festgeschriebene Rechnungen können nicht mehr bearbeitet werden.',
    'EXPENSE_IS_MISSING_REQUIRED_DATA': 'Die Ausgabe kann nicht gespeichert werden, da nicht alle Daten vollständig sind.',
    'INSUFFICIENT_PERMISSION': 'Du hast keine ausreichenden Berechtigungen für diese Aktion.',
    'INVALID_CREDENTIALS': 'Diese Zugangsdaten wurden nicht in unserer Datenbank gefunden.',
    'INVALID_EMAIL': 'Es existiert kein Benutzer mit der angegebenen Email-Adresse.',
    'INVALID_EMAIL_CONFIRMATION_TOKEN': 'Der Bestätigungslink ist abgelaufen.',
    'INVALID_PASSWORD_CONFIRMATION': 'Das eigegebene Passwort ist nicht korrekt. Bitte versuche es erneut.',
    'INVALID_PASSWORD_TOKEN': 'Der Passwortreset Token ist ungültig. Bitte versuche es erneut.',
    'INVALID_VERIFICATION_TOKEN': 'Ungültiger Verfizierungsschlüssel.',
    'INVITE_ALREADY_USED': 'Die Einladung wurde bereits angenommen.',
    'INVITE_INVALID': 'Die Einladung ist ungültig.',
    'INVOICE_IS_DRAFT': 'Entwürfe können nicht exportiert werden.',
    'INVOICE_STATUS_TRANSITION_NOT_ALLOWED': 'Der Status der Rechnung kann nicht geändert werden.',
    'INVOICE_STILL_DRAFT': 'Entwurf kann nicht bearbeitet werden.',
    'MODEL_NOT_FOUND': 'Objekt existiert nicht.',
    'NON_AUTH_ROUTE': 'Diese Seite ist nur für Gäste erreichbar.',
    'NON_DRAFTS_CANNOT_BE_DELETED': 'Nur Entwürfe können gelöscht werden.',
    'NON_DRAFTS_CANNOT_BE_UPDATED': 'Nur Entwürfe können bearbeitet werden.',
    'NOT_VERIFIED': 'Dein Account wurde noch nicht bestätigt. Bitte überprüfe dein E-Mail-Postfach.',
    'NO_EXPORTABLE_MODELS': 'Für diese Filter existieren keine exportierbaren Objekte.',
    'NO_SUBSCRIPTION': 'Bitte schließen zuerst ein Abonnement ab.',
    'NO_TOKEN': 'Deine Sitzung ist ungültig. Bitte melde dich erneut an.',
    'PDF_LOADING_FAILED': 'Die PDF Datei für diese Rechnung konnte nicht geladen werden.',
    'RECENT_PASSWORD_CHANGE': 'Dein Passwort wurde vor kurzem geändert. Bitte melde dich erneut an.',
    'SETTING_NOT_ALLOWED_FOR_PLAN': 'Dieser Tarif kann nur in Verbindung mit der Kleinunternehmerregelung (§ 19 UStG.) genutzt werden.',
    'TOKEN_BLACKLISTED': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
    'TOKEN_EXPIRED': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
    'TOKEN_INVALID': 'Deine Sitzung ist ungültig. Bitte melde dich erneut an.',
    'TOO_MANY_ATTEMPTS': 'Zu viele Anfragen in kurzer Zeit.',
    'UNKNOWN_ERROR': 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
    'USER_IS_STILL_OWNER': 'Du musst zunächst einen neuen Hauptadministrator auswählen bevor du deinen Account löschen kannst.',
    'USER_LIMIT_EXCEEDED': 'Für dieses Abbonement befinden sich zu viele Nutzer in deinem Team. Entferne Nutzer aus deinem Team und versuche es erneut.',
    'VALIDATION': 'Die eingegebenen Daten sind ungültig/unvollständig.',
    'forbidden_error_text': 'Entschuldigung, du bist nicht berechtigt diesen Inhalt zu sehen.',
    'not_found_error_text': 'Entschuldigung, der Inhalt auf den du versuchst zuzugreifen konnte nicht gefunden werden.',
    'quote_not_found_notification': 'Entschuldigung, das angegebene Angebot konnte nicht gefunden werden.'
  },

  /* english */
  en: {
    '2FA_ALREADY_ENABLED': 'Two-FActor Authentication is already enabled.',
    '2FA_INVALID': 'Two-Factor OTP is invalid.',
    '2FA_NOT_ENABLED': 'Can not verify a OTP if Two-Factor Authentication is disabled.',
    '2FA_REQUIRED': 'Two-Factor Authentication required.',
    'ACTIVE_TIME_ENTRY_EXISTS': 'There already is a running time entry. Please refresh the page to view it.',
    'ADDRESS_STILL_USED': 'One or more addresses are still used in draft or recurring invoices and could not be deleted.',
    'ALREADY_MEMBER': 'You are already a member of this company.',
    'ALREADY_SUBSCRIBED': 'You are already subscribed to a plan.',
    'CANNOT_DELETE_INITIAL_STATUS': 'The initial status can not be deleted.',
    'CAN_NOT_ADD_PAYMENT_TO_INVOICE': 'Due to the status you can not add any payment to this invoice.',
    'CAN_NOT_EDIT_COMMITTED_EXPENSE': 'Committed expenses can not be edited.',
    'COMMITTED_INVOICES_CANNOT_BE_UPDATED': 'Committed invoices can not be edited.',
    'EXPENSE_IS_MISSING_REQUIRED_DATA': 'The expense can not be saved since some data is missing.',
    'INSUFFICIENT_PERMISSION': 'Insufficient permission for this action.',
    'INVALID_CREDENTIALS': 'These credentials do not match our records.',
    'INVALID_EMAIL': 'We can\'t find a user with the given email.',
    'INVALID_EMAIL_CONFIRMATION_TOKEN': 'The confirmation link has expired.',
    'INVALID_PASSWORD_CONFIRMATION': 'The password you have entered is incorrect. Please try again.',
    'INVALID_PASSWORD_TOKEN': 'The password reset token is invalid. Please request a new token.',
    'INVALID_VERIFICATION_TOKEN': 'Invalid verification token.',
    'INVITE_ALREADY_USED': 'The invite has already been accepted.',
    'INVITE_INVALID': 'The invite is invalid.',
    'INVOICE_IS_DRAFT': 'Draft invoices can not be exported.',
    'INVOICE_STATUS_TRANSITION_NOT_ALLOWED': 'The status of this invoice can not be changed.',
    'INVOICE_STILL_DRAFT': 'Can not update a draft invoice.',
    'MODEL_NOT_FOUND': 'Model not found.',
    'NON_AUTH_ROUTE': 'This page is only available to guests.',
    'NON_DRAFTS_CANNOT_BE_DELETED': 'Only drafts can be deleted.',
    'NON_DRAFTS_CANNOT_BE_UPDATED': 'Only drafts can be updated.',
    'NOT_VERIFIED': 'You account has not been verified yet. Please check your inbox.',
    'NO_EXPORTABLE_MODELS': 'There are no exportable objects for the given filters.',
    'NO_SUBSCRIPTION': 'Please subscribe to one of our plan before.',
    'NO_TOKEN': 'Invalid session. Please login again.',
    'PDF_LOADING_FAILED': 'Failed to load the invoice PDF.',
    'RECENT_PASSWORD_CHANGE': 'Your password has been changed recently. Please login again.',
    'SETTING_NOT_ALLOWED_FOR_PLAN': 'You can only choose this plan if you use the small business regulation (§ 19 UStG.).',
    'TOKEN_BLACKLISTED': 'Your session has expired. Please login again.',
    'TOKEN_EXPIRED': 'Your session has expired. Please login again.',
    'TOKEN_INVALID': 'Invalid session. Please login again.',
    'TOO_MANY_ATTEMPTS': 'Too many attempts.',
    'UNKNOWN_ERROR': 'There was an unknown error. Please try again later.',
    'USER_IS_STILL_OWNER': 'Please choose a new primary owner for your companies before you delete your account.',
    'USER_LIMIT_EXCEEDED': 'Your team exceeds the user limitation for this plan. Please remove some team members and try again.',
    'VALIDATION': 'The input data is invalid/incomplete.',
    'forbidden_error_text': 'Sorry, you are not authorized to view this content.',
    'not_found_error_text': 'Sorry, the content you tried to access could not be found',
    'quote_not_found_notification': 'Sorry, the requested quote could not be found.'
  }
}
